import {useTransformStore} from '@/stores'
import {useRepository} from '@/composables'
import {toWsMessage} from '@/messages'
import {mediator} from '@communication'
import {useEventBus} from '@vueuse/core'
import {useThrottleFn} from '@vueuse/core'

export const useTransformCallback = () => {
  const store = useTransformStore()

  useEventBus('transform:history').on((event: any) => {
    const history = JSON.parse(event.history)
    if (history.length) {
      history.sort((a: any, b: any) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
      const filtered = history.map((data: any) => ({
        x: data.x,
        y: data.y,
        ...(data.zoom && {zoom: data.zoom}),
      }))
      const transform = filtered.reduce((acc: any, val: any) => Object.assign(acc, val), {
        zoom: 1,
        x: 0,
        y: 0,
      })
      store.setTransform(transform)
      console.info('recovered from history', {transform})
    }
  })

  useEventBus('transform:translate').on((data: any) => {
    const {x, y} = data
    store.setTranslation({x, y})
  })

  useEventBus('transform:set').on((data: any) => {
    const {zoom, x, y} = data
    store.setTransform({zoom, x, y}, true)
  })
}

export const useTransform = () => {
  const send = useThrottleFn((message: any) => {
    const {sendWsEvent} = useRepository()
    mediator.broadcast(message)
    sendWsEvent(toWsMessage(message))
  }, 1000)
  return {send}
}
